var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1619 8.41614L23.8321 4.67086C23.8642 4.63815 23.9144 4.6314 23.9539 4.65447L36.7942 12.1419C36.8557 12.1777 36.8611 12.2645 36.8046 12.3077L33.1984 15.0677M20.1619 8.41614L33.1984 15.0677M20.1619 8.41614L8.05667 16.018M33.1984 15.0677L20.1619 23.6198M33.1984 15.0677V27.8309C33.1984 28.1679 33.0287 28.4822 32.7469 28.6671L20.1619 36.9229M8.05667 16.018L1.76189 17.8533C1.67757 17.8778 1.66364 17.9914 1.73951 18.0356L7.1255 21.1763M8.05667 16.018L20.1619 23.6198M20.1619 23.6198L14.6181 25.5055C14.5906 25.5149 14.5605 25.5118 14.5355 25.4972L7.1255 21.1763M20.1619 23.6198V36.9229M7.1255 21.1763V28.7466C7.1255 29.1024 7.31447 29.4313 7.62176 29.6105L20.1619 36.9229",
    stroke: "#002D96",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.3234f5b6e35c45595e003baea8e71294.svg";
export { ForwardRef as ReactComponent };